import {assert} from 'Asserts';

import {doesDataFlowEdgeHandleReferenceRow} from './flowchartIdentifierUtils';
import {
  FlowchartStaticEdgeData,
  ProcessFlowchartEdgeType,
  TaskSchemaNodeSectionType,
  TransitionSource,
} from './processFlowchartConfigEditorConstants';
import {TaskSchemaNodeSectionData} from './processFlowchartConfigEditorNodeTypes';

export function getNodeSectionTypeFromDataFlowEdge(
  edge: FlowchartStaticEdgeData,
  nodes: Array<{id: string; sections: Array<TaskSchemaNodeSectionData>}>
): TaskSchemaNodeSectionType {
  assert(edge.type === ProcessFlowchartEdgeType.DATA_FLOW, 'Expected data flow edge');
  const sourceNode = nodes.find((node) => node.id === edge.source)!;
  assert(sourceNode != null, 'Expected source node to be found');

  for (const section of sourceNode.sections) {
    for (const row of section.sectionRows) {
      if (doesDataFlowEdgeHandleReferenceRow(edge.sourceHandle, row.clientId)) {
        return section.sectionType;
      }
    }
  }
  assert(false, 'Expected data flow edge to reference a row');
}

export function getDefaultTransitionSource(
  sourceNodeId: string,
  nodes: Array<{id: string; sections?: Array<TaskSchemaNodeSectionData>}>
): TransitionSource {
  const sourceNode = nodes.find((node) => node.id === sourceNodeId);
  assert(sourceNode != null, 'Expected source node to be found');
  return getDefaultTransitionSourceForNode(sourceNode);
}

export function getDefaultTransitionSourceForNode(node: {
  id: string;
  sections?: Array<TaskSchemaNodeSectionData>;
}): TransitionSource {
  const hasOutputSection = node.sections?.some(
    (section) => section.sectionType === TaskSchemaNodeSectionType.OUTPUTS
  );
  return hasOutputSection ? TransitionSource.OUTPUTS : TransitionSource.INPUTS;
}

export function getTransitionSourceByNodeIdPairKey(sourceNodeId: string, targetNodeId: string): string {
  return `${sourceNodeId}:${targetNodeId}`;
}

export function getNodeIdPairFromTransitionSourceKey(key: string): {
  sourceNodeId: string;
  targetNodeId: string;
} {
  const parts = key.split(':');
  assert(parts.length === 2, `Expected transition source key to contain exactly one separator, got: ${key}`);

  const [sourceNodeId, targetNodeId] = parts;
  assert(sourceNodeId.length > 0, `Expected non-empty source node ID in key: ${key}`);
  assert(targetNodeId.length > 0, `Expected non-empty target node ID in key: ${key}`);

  return {sourceNodeId, targetNodeId};
}
